export default "__VITE_ASSET__CTJA0LT5__"